"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merge_styles_1 = require("@uifabric/merge-styles");
var _ = require("underscore");
//tslint:disable-next-line
exports.SetiTheme = require('./vs-seti-icon-theme.json');
function initFontFaces(fontRoot) {
    var e_1, _a;
    var fontCalc = _.isFunction(fontRoot) ? fontRoot : function (x) { return "url(//" + fontRoot + "/assets/fonts" + x + ")"; };
    try {
        for (var _b = __values(exports.SetiTheme.fonts), _c = _b.next(); !_c.done; _c = _b.next()) {
            var font = _c.value;
            merge_styles_1.fontFace({
                fontFamily: "\"" + font.id + "\"",
                src: fontCalc(font.src[0].path.substr(1)),
                fontWeight: 'normal'
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.initFontFaces = initFontFaces;
//# sourceMappingURL=setiTheme.js.map